import { render } from "./SelecionarCliente.vue?vue&type=template&id=4ae7f717&scoped=true&ts=true"
import script from "./SelecionarCliente.vue?vue&type=script&lang=ts"
export * from "./SelecionarCliente.vue?vue&type=script&lang=ts"

import "./SelecionarCliente.vue?vue&type=style&index=0&id=4ae7f717&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae7f717"]])

export default __exports__